module.exports = __webpack_public_path__ + "static/media/Brawn.f0a68cf4.svg";